import React from "react";

import ApplicationProcedureEJ from "./ApplicationProcedureEJ";
import CareerOptionsEJ from "./CareerOptionsEJ";
import EligibilityEJ from "./EligibilityEJ";
import ObjectivesEJ from "./ObjectivesEJ";
import OutcomesEJ from "./OutcomesEJ";
import OverviewEJ from "./OverviewEJ";
import ProgramModulesEJ from "./ProgramModulesEJ";

const EJ = () => {
  return (
    <div>
      <section id="overview" className="scroll-mt-40">
        <OverviewEJ />
      </section>
      <section id="objectives" className="scroll-mt-40">
        <ObjectivesEJ />
      </section>
      <section id="eligibility" className="scroll-mt-40">
        <EligibilityEJ />
      </section>
      <section id="application-procedure" className="scroll-mt-40">
        <ApplicationProcedureEJ />
      </section>
      <section id="career-options" className="scroll-mt-40">
        <CareerOptionsEJ />
      </section>
      <section id="career-options" className="scroll-mt-40">
        <ProgramModulesEJ />
      </section>
      <section id="outcomes" className="scroll-mt-40">
        <OutcomesEJ />
      </section>
    </div>
  );
};

export default EJ;
